import styled from 'styled-components';
import { TableRow, Typography } from '@material-ui/core';

export const Title = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: bold;
  padding: 20px 0 30px;
  font-size: 3.75rem;
`;

export const BannerPreview = styled.img`
  width: 100%;
`;

export const StyledTableRow = styled(TableRow)`
  background-color: ${({ $type }) => $type && 'rgba(204 204 204 / 40%)'};
`;
